import './style.scss';

import React from 'react';
import { postData } from '@/globalFunction';

class Email extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      action: '',
      isActionSuccess: false,
      data: {},
    };
  }

  componentDidMount() {
    const location = Object.assign({}, window.location);
    const qs = new URLSearchParams(location.search);
    const action = qs.get('action');
    const key = qs.get('key');

    if (action && key) {
      switch (action) {
        case 'approved': {
          postData(`/api/emailAction/approved`, { key }, (response) => {
            if (response) {
              if (response.data.url) {
                window.location.href = response.data.url;
              } else {
                this.setState({
                  ...this.state,
                  action: action,
                  isActionSuccess: true,
                  data: response.data,
                });
              }
            }
          });

          break;
        }

        case 'acknowledge': {
          postData(`/api/emailAction/acknowledge`, { key }, (response) => {
            if (response) {
              this.setState({
                ...this.state,
                action: action,
                isActionSuccess: true,
                data: response.data,
              });
            }
          });

          break;
        }
        case 'changeRequest': {
          postData(`/api/emailAction/requestChanges`, { key }, (response) => {
            if (response) {
              if (response.data.url) {
                window.location.href = response.data.url;
              } else {
                this.setState({
                  ...this.state,
                  action: action,
                  isActionSuccess: true,
                  data: response.data,
                });
              }
            }
          });
          break;
        }
      }
    }
  }

  render() {
    if (this.state.isActionSuccess) {
      const { data } = this.state;
      return (
        <div class="emailNotificationContainer">
          <div class="emailNotifContent">
            <div class="emailHeader">
              <img
                src="/images/cloudcfo-logo-colored-icon-beside-text.png"
                class="img-responsive"
                style={{ height: '27px' }}
              />
            </div>
            <div class="emailBody">
              <div class="border-top"></div>
              <div class="emailContent">
                <h4>
                  <i
                    class={`material-icons  ${data.icon === 'error_outline' ? 'text-danger' : ''}`}
                  >
                    {data.icon}{' '}
                  </i>
                  {data.message}.
                </h4>
                <p class="mb40">{data.note}</p>
                <p>
                  Click the button to login to your CloudCfo account and View
                  the task!
                </p>
                <a
                  href={`/account#/projects/${data.projectId}/processes/tasks?action=view&taskid=${data.taskId}`}
                >
                  View in CloudCfo
                </a>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return null;
  }
}

export default Email;
